import {Injectable} from '@angular/core';
import {JSEncrypt} from 'jsencrypt';
import {environment} from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  private publicKey = environment.key.public;
  private keySize = environment.key.size;

  constructor() {
  }

  encrypt(value): string {
    const encrypt = new JSEncrypt({default_key_size: this.keySize});
    encrypt.setPublicKey(this.publicKey);
    const encrypted = encrypt.encrypt(btoa(value));
    return typeof encrypted === 'string' ? encrypted : '';
  }


}
